import { get } from '@core/api/baseApi';
import { GetFoldersResponse } from '@core/types';
import { SearchParams } from '../hooks/useFilters';

export const getFolders = (filters: SearchParams): Promise<GetFoldersResponse> =>
  get('/ReportTemplates/hierarchy', {
    params: filters,
  });
